import { Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, NotificationService } from '@services';
import { PasswordValidator } from '@validators';

@Component({
  selector: 'app-account-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class AccountPasswordComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  public form: FormGroup;

  private token: string | null;

  constructor() {
    const route = inject(ActivatedRoute);

    this.token = route.snapshot.params['token'];
    this.form = new FormGroup(
      {
        password: new FormControl('', [PasswordValidator]),
        confirmPassword: new FormControl('', [PasswordValidator]),
      },
      this.passwordMatchValidator,
    );
  }

  public onSubmit(): void {
    if (!this.token) {
      return;
    }

    this.form.markAsPending();

    this.authService
      .confirmPasswordRecovery(this.token, this.form.value.password)
      .subscribe({
        next: () => {
          this.router.navigate(['/']).finally(() => {
            this.notificationService.success('Password changed successfully.');
          });
        },
        error: (err) => {
          console.error(err);
          this.notificationService.error('Failed to change password.');
        },
      });
  }

  private passwordMatchValidator(
    control: AbstractControl<FormGroup>,
  ): ValidationErrors | null {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    if (password?.value !== confirmPassword?.value) {
      const err = { passwordMismatch: true };
      if (confirmPassword) {
        confirmPassword.setErrors(err);
      }

      return err;
    }

    return null;
  }
}
